import InlineTable from '../primitives/InlineTable';
import { buildBreadcrumb } from '../lib/breadcrumbFormat';
import {
    buildColumns,
    buildRows,
    parentName,
    pinnedTitleParts,
    excludedTerms,
} from '../lib/tableHelpers';
import type { TableModel, VisualProps, VisualWidget } from '../types';

const NAME_KEY = 'brand_name';
const TYPE_LABEL = 'Brand';

/** `brands_inline_table` — top brands within a category. */
function buildBrandsTableModel({
    input,
    output,
    title: customTitle,
}: VisualProps): TableModel {
    const columns = buildColumns(input?.order_by);
    return {
        breadcrumb: buildBreadcrumb(output, TYPE_LABEL),
        title: {
            custom: customTitle || undefined,
            parent: parentName(output),
            noun: 'brands',
            ...pinnedTitleParts(output, NAME_KEY),
            ...excludedTerms(input, output),
            lifeCycle: input?.life_cycle,
            price: input?.price,
        },
        link: output?.result?.dashboard_url,
        nameColumnHeader: 'Brand',
        columns,
        rows: buildRows(output, columns, NAME_KEY),
    };
}

const BrandsInlineTable = ({
    Frame,
    dense,
    onExcludeRow,
    ...props
}: VisualProps) => (
    <InlineTable
        {...buildBrandsTableModel(props)}
        Frame={Frame}
        dense={dense}
        onExcludeRow={onExcludeRow}
    />
);

const widget: VisualWidget = {
    match: (input) =>
        input?.entity_type === 'category' &&
        input?.entity_relationship === 'brands',
    Component: BrandsInlineTable,
};

export default widget;
